  <!-- 发票管理 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug
      :btndata="BTN_CONFIG"
      @btnEvent="callBack"
      @clearBtns="clearBtns"
      @moreParam="moreParam"
      @queryBtn_ok="queryBtn_ok"
      ref="btnList"
    />
    <!-- 查询列表 -->
    <input-plug
      ref="queryForm"
      :form-config="baseConfig"
      :form-data="queryData"
      :More="isHaseMore"
    >
      <template slot="time1">
        <multitime
          :timeType="timeType"
          :timeTypes="timeTypes"
          :startTime="startTime_a"
          :endTime="endTime_a"
          @timestatus="timestatus"
          @queryBtn_ok="queryBtn_time"
        />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :totals="totalArr"
      ref="mytable"
      @selectChange="handleSelectionChange"
      @rowCallback="rowCallback"
    />
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />

    <!--        自定义表头           -->
    <!-- 
          * 表头的方法提取到Mixin.js里面了
            show_sortTableHeard、allCheck、originalTabelHeadeTitle、selectLength
            confirmOk、checktab、checkAll、closeDias、cancelSortHeard
           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
  </div>
</template>
     <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import ImgUpload from "@/components/Modules/ImgUpload.vue";
import RecordTable from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue";
export default {
  mixins: [mixin_1],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    ImgUpload,
    RecordTable,
  },
  data() {
    return {
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新建",
          method: "create_m",
          permissVal: "admin:invoice:addInvoice",
        },

        {
          name: "开票确认",
          method: "InvoicesComfirms",
          permissVal: "admin:invoice:updateInvoice",
        },
        {
          name: "批量删除",
          method: "delete",
          permissVal: "admin:invoice:delInvoice",
        },
        {
          name: "批量取消确认",
          method: "UnComfirms",
          permissVal: "admin:invoice:cancelInvoiceSure",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "导出",
          method: "exportData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },
        {
          type: "input",
          label: "发票号码",
          field: "invoiceNumber",
          placeholder: "请输入",
        },

        {
          type: "select",
          label: "状态",
          field: "invoiceStatus",
          placeholder: "请选择",
          selectOptions: [
            { label: "已开票", val: "yi_kai_piao:invoice_status" },
            { label: "待开票", val: "dai_kai_piao:invoice_status" },
          ],
        },
      ],

      queryData: {
        invoiceNumber: null,
        invoiceStatus: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "开票日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      pageGroupName: "InvoicesControl",
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 220,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:invoice:updateInvoice",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:invoice:delInvoice",
            },
            {
              method: "UnComfirms",
              methodName: "取消确认",
              permissVal: "admin:invoice:cancelInvoiceSure",
            },
          ],
        },
        {
          name: "编号",
          field: "number",
          width: "130", // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计 default：false
          isSort: true, //表格设置里面是否可以排序 default：false
        },
        {
          name: "状态",
          field: "invoiceStatusShow",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "发票类型",
          field: "invoiceType",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "对账单号",
          field: "accountStatementNumber",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "发票号码",
          field: "invoiceNumber",
          width: "130",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "开票日期",
          field: "openInvoiceDate",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "开票项目",
          field: "invoiceProject",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "开票金额",
          field: "needInvoiceAmount",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "客户税率",
          field: "customerTaxRate",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "客户税金",
          field: "customerTaxAmount",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "发票税率",
          field: "costTaxRate",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "发票税金",
          field: "costTaxAmount",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "付款方名称",
          field: "payerName",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: "付款方识别号",
          field: "payerNumber",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "收款方名称",
          field: "payeeName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "收款方识别号",
          field: "payeeNumber",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "备注",
          field: "remark",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "创建人",
          field: "createUserName",
          sort: 120,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        // {
        //   name: "创建时间",
        //   field: "areaCountryName",
        //   sort: 6,
        //   isShow: true,
        // },
        {
          name: "开票确认人",
          field: "sureUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: "开票确认时间",
          field: "sureTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
      ],
      pageGroupName: "InvoicesControl",
      sortName: "开票管理", //  排序名
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.GetData();
  },
  methods: {
    // 导出
    exportData() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableConfig.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    // 获取发票列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startOpenInvoiceDate = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endOpenInvoiceDate = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.$API.InvoiceList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---发票列表`);
        }
      });
    },
    // 新建
    create_m() {
      this.$router.push({
        path: "/FM/InvoicesAdd/1",
        query: {
          add: "create",
        },
      });
    },
    // 修改
    modifyClick(e) {
      this.$router.push({
        path: "/FM/InvoicesAdd/1",
        query: {
          invoiceId: e.invoiceId,
        },
      });
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              invoiceIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.invoiceIds.push(val.invoiceId);
            });
            this.$API.delInvoice(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.invoiceIds.length > 2) {
                    delReq.invoiceIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.invoiceId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.invoiceId == delReq.invoiceIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 开票确认
    InvoicesComfirms(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.$router.push({
          path: "/FM/InvoicesAdd/1",
          query: {
            invoiceId: this.selectTableData[0].invoiceId,
            type: "COMFIRM",
          },
        });
      }
    },
    // 取消确认
    UnComfirms(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确认要把所选数据取消开票确认？", "提示:")
          .then((res) => {
            let cancelReq = {
              invoiceIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              cancelReq.invoiceIds.push(val.invoiceId);
            });
            this.$API.cancelInvoiceSure(cancelReq).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.GetData();
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 表格设置
    SetTable() {
      this.$TOOLS.myModel(this);
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // 表格右侧按钮回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
  },
};
</script>
    <style scoped lang="less">
</style>
                      